// Synthesised "cha-ching" via Web Audio API — no asset to ship and no
// autoplay-policy headaches once the page has had any user interaction
// (clicking, navigating). Calls are no-ops if AudioContext isn't available.

let ctx = null;

function getCtx() {
  if (ctx) return ctx;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  try { ctx = new Ctor(); } catch { ctx = null; }
  return ctx;
}

export function playChing({ volume = 0.25 } = {}) {
  const ac = getCtx();
  if (!ac) return;
  // If the context is suspended (no user gesture yet), bail quietly.
  if (ac.state === "suspended") {
    ac.resume?.().catch(() => {});
    if (ac.state === "suspended") return;
  }

  const now = ac.currentTime;
  const master = ac.createGain();
  master.gain.value = volume;
  master.connect(ac.destination);

  // Two-note rising chime: B5 then E6.
  const playNote = (freq, when, dur) => {
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.type = "sine";
    o.frequency.value = freq;
    g.gain.setValueAtTime(0.0001, now + when);
    g.gain.exponentialRampToValueAtTime(1.0, now + when + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, now + when + dur);
    o.connect(g).connect(master);
    o.start(now + when);
    o.stop(now + when + dur + 0.05);
  };

  playNote(987.77, 0.0,  0.22); // B5
  playNote(1318.5, 0.07, 0.32); // E6
}
